
import { motion } from "framer-motion";

const AudienceSection = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="bg-white/5 rounded-xl p-8 backdrop-blur-sm border border-white/10 mb-12 hover:bg-white/10 transition-colors duration-300"
    >
      <h2 className="text-3xl md:text-4xl font-bold text-racing-accent mb-6">
        A Game For Everyone
      </h2>
      <div className="space-y-6 text-gray-300">
        <p className="text-lg">
          Front Runner: Racehorse Manager is designed for a wide range of players:
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          {[
            "Web3 gaming enthusiasts will appreciate the blockchain ecosystem integration",
            "Casual gamers can enjoy quick sessions without long-term commitments",
            "Sports management fans will love the strategic depth",
            "Horse racing enthusiasts get a new way to engage with the sport"
          ].map((text, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/5 p-4 rounded-lg border border-white/10"
            >
              {text}
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default AudienceSection;
